document.addEventListener('DOMContentLoaded', function () {
let videosSwiper = new Swiper(".video-carousel__swiper", {
    slidesPerView: 'auto',
    centeredSlides: true,
    spaceBetween: 16,
    loop: true,
    navigation: {
        nextEl: ".video-carousel-next",
        prevEl: ".video-carousel-prev",
    },
    breakpoints: {
        1000: {
            slidesPerView: 5,
        },
    },
    on: {
        click: function (event) {
            if (!this.clickedSlide?.classList.contains('swiper-slide-active')) {
                this.slideToLoop(this.clickedSlide?.getAttribute('data-info'));
                setTimeout(function () {
                    updateVideoPlayback();
                }, 0);
            }
        },
        
        slideChange: function () {
            setTimeout(function () {
                updateVideoPlayback();
            }, 0);
        },
    },
});




function updateVideoPlayback() {
    var videoSlides = document.querySelectorAll(".swiper-slide.swiper__video");

    videoSlides.forEach(function (slide) {
        var video = slide.querySelector("video");
        if (video) {
            if (slide.classList.contains('swiper-slide-active')) {
                if (isElementInViewport(slide)) {
                    video.play();
                } else {
                    video.pause();
                }
            } else {
                video.pause();
            }
        }
    });

}

function isElementInViewport(el) {
    var rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

setInterval(updateVideoPlayback, 500);
})
